import PublicAPI from "./api";

export const paymentAPI = {
    create_link: async (data) => {
        return await PublicAPI.post('/criar-link-infinitepay', data)
    },
    weebhook: async (data) => {
        return await PublicAPI.post('/webhook-infinitepay', data)
    },
    order_admin: async () => {
        return await PublicAPI.get('/admin/orders');
    },
    get_order_by_id: async (id) => {
        return await PublicAPI.get(`/orders/${id}`);
    },
    get_user_orders: async (userId) => {
        return await PublicAPI.get(`/user/${userId}/orders`);
    },
    cancel_order: async (orderId, userId) => {
        return await PublicAPI.post(`/orders/${orderId}/cancel`, { user_id: userId });
    }
}   